"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSettings = void 0;
var React = require("react");
var SettingsContext_1 = require("../SettingsContext");
function useSettings() {
    var value = React.useContext(SettingsContext_1.SettingsContext);
    // if (!SettingsContext.ready && SettingsContext.readyPromise) {
    // // NOTE that in this case your app should be wrapped with Suspense
    //   throw SettingsContext.readyPromise;
    // }
    return value;
}
exports.useSettings = useSettings;
//# sourceMappingURL=useSettings.js.map